import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgClose = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 40,
	height: 40,
	viewBox: "0 0 40 40",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsx("rect", {
		width: 40,
		height: 40,
		rx: 20,
		fill: "#FFBC0D"
	}), /* @__PURE__ */ _jsx("path", {
		d: "M23.5269 13L16.473 20L23.5269 27",
		stroke: "black",
		strokeWidth: 2,
		strokeLinecap: "round"
	})]
});
export default SvgClose;
